<template>
    <base-tabs :tabs="tabs" style="height：auto">
        <template slot-scope="{current}">
            <div class="body" v-if="current === 'versions'">
                <div class="list">

                    <template v-for="(v, i) in versions.slice(0, 4)">

                        <router-link v-if="i == 0" :key="v.id" class="tab-body-item-card" :to="v.url"
                            :style="{ background: `url(${v.bg})` }">
                            <div class="title" :title="v.title">{{ v.title }}</div>
                        </router-link>

                        <router-link v-if="i !== 0" :key="v.id" class="tab-body-item" :to="v.url">
                            <div class="tab-body-title" :title="v.title">
                                <div class="title-content">{{ v.title }}</div>
                                <div v-if="v.isTop" class="new-tag">新</div>
                            </div>
                            <div class="tab-body-desc">
                                <span>发布于 {{ v.publishTime.format('YYYY-MM-DD') }}</span>
                            </div>
                        </router-link>
                    </template>
                </div>
                <div class="extra">
                    <div style="margin-top:8px">
                        <router-link to="/more/?menu=9&label=1" target="_blank">
                            <button class="btn-link btn-link-arrow">查看更多</button>
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="body" v-if="current === 'bugs'">
                <div class="list">

                    <template v-for="(v, i) in bugs.slice(0, 4)">

                        <router-link v-if="i == 0" :key="v.id" class="tab-body-item-card" :to="v.url"
                            :style="{ background: `url(${v.bg})` }">
                            <div class="title" :title="v.title">{{ v.title }}</div>
                        </router-link>

                        <router-link v-if="i !== 0" :key="v.id" class="tab-body-item" :to="v.url">
                            
                            <div class="tab-body-title" :title="v.title">
                                <div class="title-content">{{ v.title }}</div>
                                <div v-if="v.isTop" class="new-tag">新</div>
                            </div>
                            <div class="tab-body-desc">
                                <span>发布于 {{ v.publishTime.format('YYYY-MM-DD') }}</span>
                            </div>
                        </router-link>
                    </template>

                    <!-- <router-link
                        v-for="(v) in bugs.slice(0,4)"
                        :key="v.id"
                        class="tab-body-item"
                        :to="v.url"
                    >

                        <div
                            class="tab-body-title bugs"
                            :title="v.title"
                        >{{v.title}}</div>
                        <div class="tab-body-desc">
                            <span>发布于 {{v.publishTime.format('YYYY-MM-DD')}}</span>
                        </div>
                    </router-link> -->
                </div>
                <div class="extra">
                    <div style="margin-top:8px">
                        <router-link to="/more/?menu=10&label=1" target="_blank">
                            <button class="btn-link btn-link-arrow">查看更多</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </template>
    </base-tabs>
</template>

<script>
import BaseTabs from "./BaseTabs.vue";
import { getBugsAndVersions } from '../request/article'
import { QuestionArticle, WorkorderArticle } from "../models/Article";

export default {
    components: { BaseTabs },
    data: () => ({
        tabs: [
            { title: "版本更新", key: "versions" },
            { title: "漏洞说明", key: "bugs" },
        ],
        versions: [],
        bugs: [],
    }),
    async beforeMount() {
        const { tabs, versions, bugs } = await getBugsAndVersions()
        this.tabs = tabs
        this.versions = versions
        this.bugs = bugs
    }
};
</script>

<style lang="scss" scoped>
.body {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;

    .tab-body-item-card {
        background-size: cover !important;
        ;
        display: block;
        margin: 0 -16px;
        height: 136px;
        background: red;
        position: relative;
        margin-bottom: 8px;

        .title {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(24, 40, 101, 0.7);
            padding: 11px 16px;

            font-size: 14px;
            
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;

            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }

    .tab-body-item {
        padding: 8px 0;
        display: block;
        position: relative;

        &:hover .tab-body-title {
            color: var(--action-color);
        }


        .tab-body-title {

            margin-bottom: 4px;
            display: flex;
            flex-direction: row;

            .title-content {
                font-size: var(--font-size-normal);
                line-height: var(--line-height-normal);
                color: var(--text-color-content);
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                flex: 0 1 auto;
            }

            .new-tag {
                flex: 0 0 auto;
                width: 20px;
                height: 20px;
                background: rgba(255, 90, 90, 0.15);
                border-radius: 2px;
                text-align: center;
                font-size: 12px;
                
                font-weight: 500;
                color: #FF3939;
                line-height: 20px;
                margin-top: 1px;
                margin-left: 8px;
                margin-right: -16px;
            }
        }

        .tab-body-title.bugs {
            white-space: normal;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            max-height: 44px;
        }

        .tab-body-desc {
            font-size: var(--font-size-small);
            line-height: var(--line-height-small);
            color: var(--text-color-desc);
        }

        .hr {
            height: 1px;
            width: 100%;
            position: absolute;
            top: 0;
            background: var(--hr-color-hor);
        }
    }
}

.extra {
    margin-bottom: 12px;
}

.hr-ver {
    display: inline-block;
    height: 12px;
    margin: 4px 8px;
    width: 1px;
    vertical-align: bottom;
    background: var(--hr-color-ver);
}
</style>